
"use client";
import { createContext, useContext } from 'react';

const PublicModeContext = createContext(false);

export function PublicModeProvider({ children }: { children: React.ReactNode }) {
  return (
    <PublicModeContext.Provider value={true}>
      {children}
    </PublicModeContext.Provider>
  );
}

export const useIsPublic = () => useContext(PublicModeContext);